import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MockData  {
    _originalTypeClassName = "zERP.BO.MockData";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MockData.translate = translateService;
}
this.Status = null;
this.Code = null;
this.Message = null;
this.MockDataKey = null;
this._key = this.MockDataKey = 0; 
}

static translate: TranslateService;
_key: any;
Status:any;
Code:any;
Message:any;
private _MockDataKey:any;
get MockDataKey(): any {
    return this._MockDataKey;
  }
set MockDataKey(value: any) {
    this._MockDataKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MockDataKey == null || $this.MockDataKey == 0;
            }


}